import React from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { GenericFilterDropdown } from './GenericFilterDropdown'

export const ReportTypeFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    return (
      <GenericFilterDropdown
        filterParam={FilterParam.REPORT_TYPE}
        filterName={FilterName.REPORT_TYPE}
        valueKey="reportTypes"
        isNested={isNested}
      />
    )
  },
)
